angular.module('gym.components').directive('gymActivityWidget', function() {
  return {
    restrict: 'EA',
    scope: {
      gym: '=',
      privacyModeEnabled: '=',
      dashboardVersion: '='
    },
    template: require('templates/components/dashboard/gym_activity_widget.html.slim'),
    controller: ["$scope", "$http", "ActivityService", function($scope, $http, ActivityService) {
      $scope.isLoading = true;
      $scope.activityTypes = _.union([[void 0, 'All activities']], $scope.gym.activity_filter_types);
      $scope.getActivities = function(type) {
        var params;
        $scope.isLoading = true;
        params = {
          gym_id: $scope.gym.id,
          'types[]': type
        };
        return $http.get('recent_activity', {
          params: params
        }).then(function(response) {
          $scope.isLoading = false;
          return $scope.activity = response.data;
        });
      };
      $scope.getActivities();
      $scope.contactType = function(type) {
        return `${type != null ? type.toLowerCase() : void 0}s`;
      };
      $scope.getFeedHeight = function() {
        var activityHeight, dashboardHeight, feedHeight, tasksHeight;
        dashboardHeight = angular.element(".dashboard-module-side").height();
        tasksHeight = angular.element(".due-tasks-widget") ? angular.element(".due-tasks-widget").outerHeight() : 0;
        activityHeight = angular.element(".activity-feed").height();
        feedHeight = dashboardHeight - tasksHeight;
        if (feedHeight < activityHeight) {
          return feedHeight;
        }
      };
      return $scope.activityIconClass = function(event) {
        return ActivityService.getIconClass(event);
      };
    }]
  };
});
